/**
 * A value of the data model catalog as shown in lists and headers: one the admins set looks plain; one only suggested by
 * the automatic categorization (docs/catalog.md "Suggestions") has a dashed outline, muted text and a small "suggested"
 * tag, with the reasons as its tooltip. Personal data stands out either way (it matters for the GDPR).
 */
import type { ReactNode } from 'react';
import { cx } from '../design/primitives.tsx';

export function SuggestedTag({ className }: { className?: string }) {
  return <span className={cx('text-[10px] leading-none font-medium italic opacity-75', className)}>suggested</span>;
}

export function CatalogValue({ suggested, personal, title, size = 'sm', className, children }: {
  suggested?: boolean; personal?: boolean; title?: string; size?: 'xs' | 'sm'; className?: string; children: ReactNode;
}) {
  return (
    <span title={title} data-suggested={suggested ? '1' : undefined}
      className={cx('inline-flex items-center gap-1.5 rounded-full whitespace-nowrap max-w-full min-w-0 shrink-0',
        size === 'xs' ? 'h-5 px-1.5 text-micro' : 'h-6 px-2 text-micro',
        suggested
          ? cx('border border-dashed bg-transparent', personal ? 'border-warn text-warn' : 'border-n6 text-n8')
          : personal ? 'bg-warn-soft text-warn font-medium' : 'bg-n3 text-n9',
        title && 'cursor-help', className)}>
      {personal && <i className="size-1.5 rounded-full bg-warn shrink-0" aria-hidden="true" />}
      <span className="truncate">{children}</span>
      {suggested && <SuggestedTag />}
    </span>
  );
}
